import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Shipment } from 'src/app/domain/Shipment';
import { ClientService } from 'src/app/services/client.service';
import { StepperService } from 'src/app/pages/Shared/stepper/stepper.service';
import { TenantService } from 'src/app/services/tenant.service';
import { Service } from 'src/app/domain/Service';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { OBPermissions } from '@alicetms/auth.permissions';

@Component({
  selector: 'app-service-info',
  templateUrl: './service-info.component.html',
  styleUrls: ['./service-info.component.scss'],
})
export class ServiceInfoComponent implements OnInit, OnDestroy {
  // @Input() shipment = <Shipment>{};
  @Input() shipment: Shipment = {} as Shipment;
  services: any;
  tenantServices = new Array<Service>();
  accounts: any;
  payments: any;
  InsuresAllowed = false;
  InsuresFormGroup = new FormGroup({
    Amount: new FormControl(0),
    Enabled: new FormControl(),
  });
  destroy$ = new Subject<void>();

  serviceForm = new FormGroup({
    services: new FormControl<string[]>(this.shipment.services ?? []),
    serviceData: new FormArray([]),
  });

  constructor(public stepperService: StepperService, private clientService: ClientService, private tenant: TenantService, private authService: AuthService) {
    this.shipment = this.stepperService.newShipment;
  }
  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.shipment = this.stepperService.newShipment;
    this.InsuresAllowed = this.authService.hasPermission(OBPermissions.BookInsurance);

    if (this.stepperService.recipientCustomer?.serviceCodes != null && (this.shipment.services == null || this.shipment.services?.length < 1)) {
      this.shipment.services = this.stepperService.recipientCustomer.serviceCodes;
    }
    let persistedServices = Array.from(new Set(this.shipment.services ?? []));

    if (this.shipment.services?.length > 0 && this.shipment.services.includes('FOR')) {
      this.InsuresFormGroup.controls.Enabled.setValue(this.shipment.services.includes('FOR'));
      this.InsuresFormGroup.controls.Amount.setValue(this.shipment.InsuranceAmount ?? 0);
    }
    (this.serviceForm.get('services') as FormControl<string[]>)
      .setValue(persistedServices, { emitEvent: false });

    combineLatest([this.tenant.services$, this.clientService.clientServices$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tenantServices, clientServices]) => {
        const defaultAddByKey = new Map<string, boolean>();
        clientServices.forEach(cs => {
          if (cs.id)
            defaultAddByKey.set(`id:${cs.id}`, !!cs.defaultAdd);
          if (cs.code)
            defaultAddByKey.set(`code:${cs.code}`, !!cs.defaultAdd);
        });
        if (!this.shipment.services)
          this.shipment.services = new Array<string>();

        if (this.shipment.dangerousGoods && this.shipment.dangerousGoods.length > 0) {
          if (this.shipment.services && this.shipment.services.filter(s => s == "Farliggods" || s == "Farlig Gods" || s == "ADR" || s == "Farligt gods").length < 1) {
            var serviceToAdd = clientServices.find(clientService => clientService.name == "Farliggods" || clientService.name == "Farlig Gods" || clientService.name == "ADR" || clientService.name == "Farligt gods")
            if (serviceToAdd?.name == undefined)
              console.log("no adr service found")
            else {
              this.shipment.services.push(serviceToAdd.name);
              this.serviceForm.controls.services.value.push(serviceToAdd.code);
            }

          }
        }

        const resolved: (Service & { defaultAdd?: boolean })[] = [];
        clientServices.forEach(cs => {
          let idx = tenantServices.findIndex(x => x.id === cs.id);
          if (idx === -1) idx = tenantServices.findIndex(x => x.code === cs.code);
          const base = idx !== -1 ? tenantServices[idx] : cs;
          resolved.push({ ...base, defaultAdd: defaultAddByKey.get(`id:${base.id}`) ?? defaultAddByKey.get(`code:${base.code}`) ?? false, });
        });

        this.services = resolved.length > 0 ? resolved : tenantServices.map(t => ({ ...t, defaultAdd: defaultAddByKey.get(`id:${t.id}`) ?? defaultAddByKey.get(`code:${t.code}`) ?? false, }));

        const ctrl = this.serviceForm.get('services') as FormControl<string[]>;
        const current = new Set(ctrl.value ?? []);

        this.services.filter(s => s.defaultAdd).forEach(s => current.add(s.code));
        this.services = this.services.sort((a, b) => a.name! > b.name! ? 1 : a.name == b.name ? 0 : -1);

        const next = Array.from(current);
        if ((ctrl.value ?? []).join('|') !== next.join('|')) {
          ctrl.setValue(next, { emitEvent: true });
        }
        this.shipment.services = next;
      });

    this.serviceForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.shipment.services = value.services;
        this.shipment.serviceData = (this.serviceForm.get('serviceData') as FormArray)
          .controls.reduce((map, control) => {
            map[control.get('service')?.value] = control.get('value')?.value;
            return map;
          }, {} as Record<string, string>);
      });

    this.InsuresFormGroup.controls.Enabled.valueChanges.subscribe(x => {
      if (x == 1) {
        if (this.shipment.services && !this.shipment.services.includes('FOR'))
          this.shipment.services.push('FOR')
      }
      else {
        this.shipment.services = this.shipment.services.filter(x => x != 'FOR');
        this.shipment.InsuranceAmount = 0;
      }
    });

    this.InsuresFormGroup.controls.Amount.valueChanges.subscribe(x => {
      if (this.InsuresAllowed && this.InsuresFormGroup.controls.Enabled.value == 1) {
        if (this.shipment.services && !this.shipment.services.includes('FOR'))
          this.shipment.services.push("FOR");
        this.shipment.InsuranceAmount = x;
      }
    })
    if (this.shipment.dangerousGoods && this.shipment.dangerousGoods.length > 0)
      console.log("Service info Services ", this.services)
  }


  onServiceChange(event: any) {
    // const newServices = event.checked ?? [];
    // const serviceDataArray = this.serviceForm.get('serviceData') as FormArray;
    // // Add new controls for services that require data
    // newServices.forEach((service) => {
    //   if (this.tenantServices[service]?.requiresData) {
    //     const exists = serviceDataArray.controls.some((control) => control.get('service')?.value === service);
    //     if (!exists) {
    //       serviceDataArray.push(
    //         new FormGroup({
    //           service: new FormControl(service),
    //           value: new FormControl(null, [Validators.required]),
    //         })
    //       );
    //     }
    //   }
    // });

    // // Remove controls for services that are no longer selected
    // for (let i = serviceDataArray.length - 1; i >= 0; i--) {
    //   const control = serviceDataArray.at(i);
    //   if (!newServices.includes(control.get('service')?.value)) {
    //     serviceDataArray.removeAt(i);
    //   }
    // }
    window.dispatchEvent(new CustomEvent("CheckPriceEvent", {}));
  }
  InsuresChangePreviewUpdater() {

  }

  CheckInsures() {
    // console.log("Insures formgroup: ", this.InsuresFormGroup)
  }

  CheckForAdr(s: string) {
    if ((s == "Farliggods" || s == "Farlig Gods" || s == "ADR" || s == "Farligt gods") && this.shipment.dangerousGoods.length > 0)
      return true;
    else
      return false;
  }

  getServiceDataFormGroups(): FormGroup[] {
    return ((this.serviceForm.get('serviceData') as FormArray).controls as FormGroup[]) ?? [];
  }
}

